var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { "padding-top": "1em" } },
    [
      _c("b-loading", {
        attrs: { active: _vm.isActive === null, "is-full-page": false }
      }),
      _vm.isActive !== null
        ? _c(
            "b-field",
            { attrs: { message: _vm.$t("notifications.message1") } },
            [
              _c(
                "b-switch",
                {
                  model: {
                    value: _vm.isActive,
                    callback: function($$v) {
                      _vm.isActive = $$v
                    },
                    expression: "isActive"
                  }
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$t("notifications.message2")) +
                      "\n    "
                  )
                ]
              )
            ],
            1
          )
        : _vm._e(),
      _vm.isActive
        ? _c("div", { staticClass: "notifications-frequency" }, [
            _c(
              "div",
              { staticClass: "field" },
              [
                _c(
                  "b-radio",
                  {
                    attrs: { "native-value": "daily" },
                    model: {
                      value: _vm.frequency,
                      callback: function($$v) {
                        _vm.frequency = $$v
                      },
                      expression: "frequency"
                    }
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("notifications.message3")) +
                        "\n      "
                    )
                  ]
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "field" },
              [
                _c(
                  "b-radio",
                  {
                    attrs: { "native-value": "all" },
                    model: {
                      value: _vm.frequency,
                      callback: function($$v) {
                        _vm.frequency = $$v
                      },
                      expression: "frequency"
                    }
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("notifications.message4")) +
                        "\n      "
                    )
                  ]
                )
              ],
              1
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }